<template>
<div class="kt-heading">
    <slot></slot>
</div>
</template>

<script>
export default {

}
</script>